import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { appUpdate } from '../lib/appUpdateSignal';

export default function useAppUpdatePending() {
  return useSyncExternalStore(appUpdate.subscribe, appUpdate.getSnapshot);
}
